/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_Q5Inputs */

const en_to_typescript_faq_q5 = /** @type {(inputs: To_Typescript_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why is my field typed null instead of optional?`)
};

const ko_to_typescript_faq_q5 = /** @type {(inputs: To_Typescript_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`왜 필드가 선택적이 아니라 null 타입이 되었나요?`)
};

const ja_to_typescript_faq_q5 = /** @type {(inputs: To_Typescript_Faq_Q5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`なぜフィールドが任意ではなく null 型になるのですか`)
};

/**
* | output |
* | --- |
* | "Why is my field typed null instead of optional?" |
*
* @param {To_Typescript_Faq_Q5Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_q5 = /** @type {((inputs?: To_Typescript_Faq_Q5Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_Q5Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_q5(inputs)
	if (locale === "ko") return ko_to_typescript_faq_q5(inputs)
	return ja_to_typescript_faq_q5(inputs)
});